import { VbzButton, VbzModal } from '@smiles/voebiz-ui-kit';
import React, { FC } from 'react';
import { ModalBody } from 'reactstrap';
import { error } from '../../assets';

interface ModalAlreadyRegisteredProps {
  isOpenModalAlreadyRegistered: boolean;
  toggleModalAlreadyRegistered: () => void;
}

const ModalAlreadyRegistered: FC<ModalAlreadyRegisteredProps> = ({
  isOpenModalAlreadyRegistered,
  toggleModalAlreadyRegistered,
}) => {
  return (
    <>
      <VbzModal
        isOpen={isOpenModalAlreadyRegistered}
        type="right"
        desktopSize="small"
        toggle={toggleModalAlreadyRegistered}
      >
        <ModalBody>
          <div className="modal-already-registered__image">
            <img src={error} alt="mala quebrada" />
          </div>
          <div className="modal-already-registered__title">
            <h3>Você já está cadastrado nessa promoção. </h3>
          </div>

          <div className="modal-already-registered__description">
            <p>Continue aproveitando a promoção e todos os benefícios de ser cliente VoeBiz!</p>
            <div className="error-modal-btn">
              <VbzButton
                id="error-modal-btn"
                className="mt-5 error-modal-button"
                color="primary"
                text="Entendi"
                onClick={toggleModalAlreadyRegistered}
              />
            </div>
          </div>
        </ModalBody>
      </VbzModal>
    </>
  );
};
export default ModalAlreadyRegistered;
